module.exports = __webpack_public_path__ + "img/IMG_3495.0eabcdd5.jpg";